module.exports = __webpack_public_path__ + "assets/img/ee21-mz.svg";